import AgreementViewer from '@/modules/agreements/viewer/AgreementViewer';

export default [
	{
		path: '/document/:id',
		name: 'Agreement',
		component: AgreementViewer,
		props: (route) => ({ id: route.params.id, secretKey: route.query.secretKey, print: route.query.print === '1', inFrame: route.query.inFrame === 'true' }),
		meta: {
			insecure: true,
		},
	},
	{
		// An agreement template's public link: the visitor fills in, pays and signs their own copy
		path: '/docs/:slug',
		name: 'PublicAgreement',
		component: AgreementViewer,
		props: (route) => ({ publicSlug: route.params.slug, inFrame: route.query.inFrame === 'true' }),
		meta: {
			insecure: true,
		},
	},
]